import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { Container, Label, Input, Button } from 'reactstrap';
import CustomDraggable from '../../../../Components/Common/CustomDraggable';
import FieldCollapse from './FieldCollapse';
import { setFeedInfoFeed, setIsChangesMade, setPreview } from '../../../../slices/feeds/reducer';
import checkPermission from '../../../../Components/Hooks/PermissionHook';

function Fields() {
  const dispatch = useDispatch();

  const selectFeedInfo = createSelector((state) => state.Feed, (state) => ({
    feedInfo: state.feedInfo,
  }));
  const { feedInfo } = useSelector(selectFeedInfo);

  const selectBrandPath = createSelector(state => state.MenuData, state => state.brandPath);
  const brandPath = useSelector(selectBrandPath);
  
  return (
    <CustomDraggable
      data={(feedInfo !== null ? feedInfo.feed : [])}
      setData={(data) => {
        dispatch(setFeedInfoFeed(data));
        dispatch(setIsChangesMade(true));
      }}
      children={<FieldCollapse />}
      permission={checkPermission("brands", brandPath, "feedEdit")}
    />
  )
}

export default Fields;